<template>
  <div class="invoice-bill-list">
    <div class="table-bd">
      <custom-table index :data="data" tableCode="invoice_bill" :slots="['invoiceAmount', 'termNum', 'finalPayment']">
        <template slot="termNum" slot-scope="scope">
          {{ scope.row.termNum }}/{{ scope.row.totalTerm }}
        </template>
        <template slot="finalPayment" slot-scope="scope">
           {{ type ? '-' : '' }}{{ isApply ? scope.row.paymentAmount : scope.row.finalPayment }}
        </template>
        <template slot="invoiceAmount" slot-scope="scope">
          {{ type ? '-' : '' }} {{   isApply ? scope.row.thisInvoiceAmount: scope.row.invoiceAmount  }}
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    type: { type: Boolean, default: false },
    isApply: { type: Boolean, default: false },
  },
  computed: {},
  data() {
    return {
      // normalItemList: [],
      // details: {
      //   customer: {
      //     address: '',
      //     tell: '',
      //     depositBank: '',
      //     depositNumber: ''
      //   },
      //   service: {
      //     address: '',
      //     tell: '',
      //     depositBank: '',
      //     depositNumber: ''
      //   },
      //   normalItemList: [],
      // },
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss">
.invoice-bill-list {
  // width: 925px;
  // border: 1px solid #800000;
  // margin: 0 auto 35px;
  // padding:0 48px 0px;

  .header {
    text-align: center;
    position: relative;
    height: 118px;
    border-left: 1xp solid #800000;
    border-right: 1xp solid #800000;
    h2 {
      color: #9f5008;
      padding-bottom: 10px;
      border-bottom: 1px solid #800000;
      letter-spacing: 3px;
      border-bottom-style: double;
      border-bottom-width: 4px;
      display: inline-block;
      text-align: center;
      font-size: 28px;
      line-height: 40px;
      margin-top: 32px;
    }
    .date {
      position: absolute;
      right: 46px;
      bottom: 25px;
      color: #000000;
      h3 {
        height: 25px;
        font-size: 18px;
        padding-bottom: 8px;
        line-height: 25px;
        letter-spacing: 1px;
      }
      p {
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 1px;
      }
    }
  }
  .main {
    color: #9f5008;
    border-left: 1px solid #800000;
    border-right: 1px solid #800000;
    .purchaseArea {
      display: flex;
      // flex-direction:column;
      height: 100px;
      .purchaser {
        width: 530px;
        flex: 0 0 530px;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          // line-height: 100px
          padding: 15px 8px;
        }
        .name {
          width: 500px;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          p {
            padding: 3px 0;
            font-size: 12px;
            span {
              color: #000000;
            }
          }
        }
      }
      .passwordArea {
        flex: 1;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          padding: 15px 8px;
          height: 100px;
        }
        .hidden {
          flex: 1;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          border-right: 0;
        }
      }
    }
    .order {
      li {
        display: flex;

        div {
          padding: 0 10px;
          flex: 1;
          border: 1px solid #800000;
          border-bottom: 0;
          border-left: 0;
          border-top: 0;
          text-align: center;
          // border-right:0
        }
        div:first-of-type {
          flex: 0 0 200px;
        }
        div:last-of-type {
          border-right: 0;
        }
      }

      .theader {
        border-top: 1px solid #800000;
        height: 35px;
        line-height: 35px;
        font-size: 12px;
      }
      .line {
        // padding-top:6px;
        color: #000000;
        line-height: 17px;
        font-size: 12px;
        div {
          padding-top: 6px;
        }
      }
      .total {
        height: 50px;
        line-height: 70px;
        color: #000000;
        div:first-of-type {
          color: #9f5008;
        }
      }
    }
    .total-tax {
      height: 36px;
      line-height: 36px;
      display: flex;
      div {
        border: 1px solid #800000;
        border-left: 0;
        border-bottom: 0;
        border-right: 0;
      }
      .tax-title {
        flex: 0 0 200px;
        border-right: 1px solid #800000;
        text-align: center;
      }
      .tax-left {
        flex: 1;
        padding-left: 20px;
        color: #000000;
      }
      .tax-right {
        flex: 1;
        padding-left: 20px;
        color: #000000;
      }
    }
    .sales {
      display: flex;
      // flex-direction:column;
      height: 100px;
      .seller {
        width: 530px;
        flex: 0 0 530px;
        display: flex;
        .title {
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          // line-height: 100px
          padding: 15px 8px;
        }
        .name {
          width: 500px;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
        }
        p {
          padding: 3px 0;
          font-size: 12px;
          span {
            color: #000000;
          }
        }
      }
      .remark {
        flex: 1;
        display: flex;
        .title {
          // writing-mode: tb-rl;
          width: 30px;
          flex: 0 0 30px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          padding: 15px 8px;
          height: 100px;
        }
        .text {
          flex: 1;
          padding-left: 10px;
          border: 1px solid #800000;
          border-left: 0;
          border-bottom: 0;
          border-right: 0;
          color: #000000;
        }
      }
    }
  }
  .footer {
    border-top: 1px solid #800000;
    line-height: 36px;
    color: #9f5008;
    span {
      color: #000000;
    }
  }
}
</style>
